<template>
  <div>
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                v-if="getPermissionModule('Tags').adjust"
                :btn-label="'Tags'"
                @click.native="$router.push('/tags/create')"
              />
              <!-- hold -->
              <!-- <export-button class="ml-2" @onExport="onOpenExportModal" /> -->
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="fields"
                :items="tagsListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table"
              > -->
              <b-table
                :fields="fields"
                :items="tagsListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table-vertical"
              >
                <!-- <template #cell(tag_name)="data">
            <div :style="{color : 'red'}">{{data.item.tag_name + data.item.string_value}}</div>
          </template> -->
                <!-- <template #cell(seq)="data">
              <span>{{ data.index + 1 }}</span>
            </template> -->
                <template #cell(string_val)="data">
                  <span>{{ data.item.data.string_val || "-" }}</span>
                </template>
                <template #cell(int_val)="data">
                  <span>{{ data.item.data.int_val || "-" }}</span>
                </template>
                <template #cell(decimal_val)="data">
                  <span>{{ data.item.data.decimal_val || "-" }}</span>
                </template>
                <template #cell(bool_val)="data">
                  <span>{{ data.item.data.bool_val || "-" }}</span>
                </template>
                <template #cell(latest_update)="data">
                  <div>
                    {{
                      data.item.updated_time
                        ? resolveDate(data.item.updated_time) +
                          " " +
                          resolveTime(data.item.updated_time)
                        : "-"
                    }}
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div v-if="getPermissionModule('Tags').adjust" class="d-flex align-item-center">
                    <edit-icon
                      class="svg-icon mr-4 iconEdit-btn"
                      @click.native="
                        $router.push('/tags/info/' + data.item.tag)
                      "
                      v-b-tooltip.hover
                      title="Edit"
                    />
                    <delete-icon
                      class="svg-icon"
                      @click.native="onRemoveTag(data.item)"
                      v-b-tooltip.hover
                      title="Delete"
                    />
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <!-- hold -->
    <!-- <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.category"
      :moduleKey="defaultReportCategory.tag"
    /> -->
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useTagsList from "./hooks/useTagsList";
import ExportButton from "@/views/components/button/ExportButton.vue";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";
import {
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";
export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    vSelect,
    EditIcon,
    DeleteIcon,
    PaginationWithReorder,
    ExportButton,
    HistoryReportModal,
  },
  setup() {
    const {
      fields,
      loading,
      tagsListTable,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      resolveDate,
      resolveTime,
      onRemoveTag,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      getPermissionModule
    } = useTagsList();
    return {
      fields,
      loading,
      tagsListTable,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      resolveDate,
      resolveTime,
      onRemoveTag,
      defaultReportFilterType,
      defaultReportCategory,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      getPermissionModule
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
